module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAQAAAC1QeVaAAAAAXNSR0IArs4c6QAAAKdJREFUGBmlwbEqRXEAB+Bfput27mBgUQbKSxiE1UuQyeAV7ma4u80iZZG6KQsPIZtYbUYLxfmcv+N2j9h8Xwp9vXxzY2QpEwaePRrkixk9+3bTcqTGrSoNe04tOLCawr3WdRrWLDpPHKYw1jpOw9CGncQ4hU21Yjm/mfWiuMhfbHnFuzMrRq5U6TL0YepOlS5Db6ae9NNlXW2iNpefVLZdenBiPv/yCY6mlQYs/SiYAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/notariaIndex/white-phone.png
// module id = LjXT
// module chunks = 0